var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("You don't have access to the path \""+_vm._s(_vm.$route.query.redirect)+"\"")]),_c('v-btn',{attrs:{"to":"/settings","color":"primary"}},[_vm._v("Settings")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }